const menuButton = document.getElementById('js-menu-button');
const globalMenu = document.getElementById('js-nav');

// MENU関連
const toggleMenu = (isOpen) => {
  const ariaExpandedValue = isOpen ? 'true' : 'false';
  const ariaLabelValue = isOpen ? 'メニューを閉じる' : 'メニューを開く';
  const ariaHiddenValue = isOpen ? 'false' : 'true';

  menuButton.setAttribute('aria-expanded', ariaExpandedValue);
  menuButton.setAttribute('aria-label', ariaLabelValue);
  globalMenu.setAttribute('aria-hidden', ariaHiddenValue);
};


const clickMenuButton = () => {
  const handleClick = e => {
    if (e.currentTarget.getAttribute('aria-expanded') === 'false') {
      toggleMenu(true);
    } else {
      toggleMenu(false);
    }
  };

  menuButton.addEventListener('click', handleClick);
};

const changeNavMediaQuery = () => {
  const breakPoint = '768px';

  const mql = window.matchMedia(`(min-width: ${breakPoint}`);

  const mediaQueryHandler = (e) => {
    if (e.matches) {
      toggleMenu(true);
    } else {
      toggleMenu(false);
    }
  };

  mql.addEventListener('change', mediaQueryHandler);

  mediaQueryHandler(mql);
};

export default () => {
  clickMenuButton();
  changeNavMediaQuery();
};
